import React, { Fragment } from 'react'
import { withTheme } from 'styled-components'

const Switch = withTheme(props => {
  let { value, onClick, name = '', class: className = '', labelLeft, labelRight } = props

  return (
    <Fragment>
      <div className={`z1-switch ${className}`}>
        <label htmlFor={name} className='z1-switch-label' onClick={onClick}>
          <input id={name} className='z1-toggle z1-toggle-round' type='checkbox' readOnly checked={!!value} />
          <span className='switch-state switch-label-no'>{labelLeft}</span>
          <label htmlFor={name} className='z1-switch-btn' />
          <span className='switch-state switch-label-yes'>{labelRight}</span>
        </label>
      </div>
      <style jsx global>
        {`
          .z1-switch {
            display: inline-block;
            vertical-align: middle;
            line-height: 35px;
          }

          .z1-toggle {
            position: absolute;
            z-index: -1000;
            top: 0;
            visibility: hidden;
          }

          .z1-toggle + span + label.z1-switch-btn,
          .z1-toggle + label.z1-switch-btn {
            display: inline-block;
            position: relative;
            cursor: pointer;
            outline: none;
            user-select: none;
            vertical-align: middle;
            margin: 0 0 0 0;
          }

          input.z1-toggle-round + span + label.z1-switch-btn,
          input.z1-toggle-round + label.z1-switch-btn {
            padding: 2px;
            width: 40px;
            height: 20px;
            background-color: ${props.theme.colors.grey.light};
            border-radius: 60px;
            transition: background 0.4s;
          }

          input.z1-toggle-round + span + label.z1-switch-btn:before,
          input.z1-toggle-round + span + label.z1-switch-btn:after,
          input.z1-toggle-round + label.z1-switch-btn:before,
          input.z1-toggle-round + label.z1-switch-btn:after {
            display: block;
            position: absolute;
            content: '';
          }

          input.z1-toggle-round + span + label.z1-switch-btn:before {
            right: 1px;
            border-radius: 60px;
            transition: background 0.4s;
          }

          input.z1-toggle-round + span + label.z1-switch-btn:after,
          input.z1-toggle-round + label.z1-switch-btn:after {
            width: 16px;
            height: 16px;
            top: 2px;
            left: 2px;
            background-color: ${props.theme.colors.white.default};
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
            border-radius: 100%;
            transition: margin 0.4s, background 0.4s;
          }

          input.z1-toggle-round:checked + span + label.z1-switch-btn,
          input.z1-toggle-round:checked + label.z1-switch-btn {
            background-color: ${props.theme.colors.primary};
          }

          .z1-switch-public .z1-label {
            font-size: 11px;
          }

          input.z1-toggle-round:checked + span + label.z1-switch-btn:after,
          input.z1-toggle-round:checked + label.z1-switch-btn:after {
            margin: 0 0 0 20px;
          }

          input.z1-toggle-round[disabled] + span,
          input.z1-toggle-round[disabled] + span + label,
          input.z1-toggle-round[disabled] + span + label + span {
            cursor: not-allowed;
          }

          input.z1-toggle-round[disabled]:checked + span + label.z1-switch-btn + span.switch-state,
          input.z1-toggle-round[disabled] + span + label.z1-switch-btn + span.switch-state {
            color: ${props.theme.colors.grey.default};
          }

          input.z1-toggle-round[disabled]:checked + span.switch-label-no {
            color: ${props.theme.colors.grey.default};
          }

          input.z1-toggle-round[disabled] + span.switch-label-no {
            color: ${props.theme.colors.black.cool};
          }

          input.z1-toggle-round[disabled] + span + label.z1-switch-btn:after,
          input.z1-toggle-round[disabled] + label.z1-switch-btn:after {
            background-color: ${props.theme.colors.grey.default};
          }

          input.z1-toggle-round:checked + span + label.z1-switch-btn + span.switch-state {
            color: ${props.theme.colors.primary};
          }

          input.z1-toggle-round + span.switch-label-no {
            color: ${props.theme.colors.black.light};
          }

          input.z1-toggle-round:checked + span.switch-label-no {
            color: ${props.theme.colors.grey.default};
          }

          input.z1-toggle-round:checked ~ span.switch-label-yes {
            color: ${props.theme.colors.primary};
          }

          input.z1-toggle-round + span + label.z1-switch-btn + span.switch-label-yes {
            margin: 0 0 0 10px;
          }

          input.z1-toggle-round:checked + span + label.z1-switch-btn + span.switch-label-yes {
            color: ${props.theme.colors.primary};
            font-weight: 500;
          }

          input.z1-toggle-round:checked + span.switch-label-no {
            font-weight: 400;
          }

          input.z1-toggle-round:not(:checked) + span + label.z1-switch-btn + span.switch-label-yes {
            color: ${props.theme.colors.grey.default};
          }

          input.z1-toggle-round + span.switch-label-no {
            margin: 0 10px 0 0;
          }

          .switch-state {
            font-weight: 400;
            color: ${props.theme.colors.black.light};
            font-size: 12px;
          }

          .switch-state-content {
            display: inline-block;
          }

          .switch-state-content input.z1-toggle-round + span + label.z1-switch-btn:after {
            background-color: ${props.theme.colors.primary};
          }

          .switch-state-content .switch-state.active {
            color: ${props.theme.colors.primary};
          }

          .switch-state-content .switch-state:not(.active) {
            color: ${props.theme.colors.red.default};
          }
        `}
      </style>
    </Fragment>
  )
})

export default Switch
